package app.nestbridge.domain.identity.api.model

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class ProfessionalProfileDto(
    val id: String,
    val userId: String,
    val displayName: String,
    val credentials: List<String> = emptyList(),
    val affiliation: String,
    val primaryServiceProvided: ProfessionalServiceTypeDto,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
)
